// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Gi","edit_box_title":"Hi","subscription":"Ii","byb":"Ji","recommended_for_you_title":"Ki","explore":"Li","recommended":"Mi","go_back":"Ni","wrapper":"Oi","product_img":"Pi","info":"Qi","remove_btn":"Ri"};
    if(module.hot) {
      // 1715276852772
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  